import React from "react";
import { Path } from "enums";
import { Route, Switch, Redirect } from "react-router-dom";
import RFIDModule from "modules/rfid/rfid.module";

const RFIDPage = () => {
  return (
    <Switch>
      <Route exact path={Path.ConsumerRFID} component={RFIDModule} />
      <Redirect to={Path.ConsumerRFID} />
    </Switch>
  );
};

export default RFIDPage;
